import React from 'react'
import { SkinCoatBenefitsRoot, SkinCoatBenefitsContainer } from './SkinCoatBenefits.styles'
import { CopyColumnHeader } from '../../RawBenefits.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import dogWithPack from '../../../../../public/assets/raw-benefits/golden-retriever-holding-we-feed-raw-pack.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Trans from 'next-translate/Trans'

export const SkinCoatBenefits: React.FC = () => {
  const { t } = useTranslation()

  const SkinCoatCopy = () => (
    <Stack gap="3" direction="column">
      <CopyColumnHeader>{t('raw-benefits:skin-coat-benefits.title')}</CopyColumnHeader>
      <Text>
        <Trans
          i18nKey="raw-benefits:skin-coat-benefits.body.0"
          components={{ Bold: <Text weight="bold" /> }}
        />
      </Text>
      <Text>{t('raw-benefits:skin-coat-benefits.body.1')}</Text>
      <Text>{t('raw-benefits:skin-coat-benefits.body.2')}</Text>
    </Stack>
  )

  return (
    <SkinCoatBenefitsRoot>
      <SkinCoatBenefitsContainer>
        <ImageWithText
          copyColumn={<SkinCoatCopy />}
          imageSrc={dogWithPack}
          imageAlt="raw-benefits:skin-coat-benefits.image-alt"
          imageSide="left"
          isMobileImageBottom
        />
      </SkinCoatBenefitsContainer>
    </SkinCoatBenefitsRoot>
  )
}

SkinCoatBenefits.displayName = 'SkinCoatBenefits'
